import React from 'react'

import CreditNote from '../components/credit-note/index'

class CreditNotePage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<CreditNote />
			</div>
		)
	}

}

export default CreditNotePage;


// WEBPACK FOOTER //
// ./src/containers/credit-note-page.js